import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetEmailTemplateGroup as GetEmailTemplateGroupQuery,
    GetEmailTemplateGroupVariables as GetEmailTemplateGroupQueryVariables,
    GetEmailTemplateGroup_emailSequenceTemplateGroup as Group,
} from 'nutshell-graphql-types';

import GET_EMAIL_TEMPLATE_GROUP from '../queries/get-email-template-group.graphql';

export const useGetEmailTemplateGroup = ({
    groupId,
    search,
    creatorIds,
    onlyArchived,
    includeShared,
    includeUnsharedFromOthers,
}: {
    groupId: string;
    search?: string;
    creatorIds?: string[];
    onlyArchived?: boolean;
    includeShared?: boolean;
    includeUnsharedFromOthers?: boolean;
}): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    emailSequenceTemplateGroup: Group;
} => {
    const {loading, data, error} = useQuery<
        GetEmailTemplateGroupQuery,
        GetEmailTemplateGroupQueryVariables
    >(GET_EMAIL_TEMPLATE_GROUP, {
        variables: {
            id: groupId,
            creatorIds,
            search,
            onlyArchived,
            includeShared,
            includeUnsharedFromOthers,
        },
        notifyOnNetworkStatusChange: true,
    });

    const {emailSequenceTemplateGroup} = makeDataDangerous(data);

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        emailSequenceTemplateGroup: emailSequenceTemplateGroup,
    };
};
